var _title, _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGplus = function SvgGplus(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "gplus")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.592 4.16c-4.704 0.656-8.512 3.952-9.968 8.64-0.544 1.728-0.544 4.832 0 6.56 2.304 7.392 10.224 10.832 17.056 7.408 2.928-1.456 5.104-3.952 6.176-7.040 0.24-0.704 0.304-1.328 0.304-2.96v-2.048h-11.216l0.048 1.872 0.048 1.888 6.784 0.16-0.464 0.96c-1.312 2.688-4.064 4.416-7.088 4.448-6 0.048-9.888-6.144-7.232-11.52 2.24-4.544 8.032-5.84 12.112-2.72l0.736 0.56 0.848-0.896c0.48-0.512 1.088-1.152 1.344-1.44l0.48-0.544-0.8-0.704c-0.992-0.88-3.344-2.064-4.72-2.368-1.408-0.32-3.232-0.416-4.448-0.256z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.52 13.6v1.12h-2.24v1.92h2.224l0.048 1.152 0.048 1.168h1.92l0.048-1.168 0.048-1.152h2.224v-1.92h-2.24v-2.24h-2.080v1.12z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGplus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gplus.bcdc41bb.svg";
export { ForwardRef as ReactComponent };